/**
 * @flow
 * @relayHash 558495205e5502f0ca90f8eb26e24c43
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CommentsWidgetListPaginationQueryResponse = {|
  +question: ?{| |};
|};
*/


/*
query CommentsWidgetListPaginationQuery(
  $questionId: ID!
  $from: String!
  $to: String!
  $deviceIds: [ID]!
  $filterComments: Boolean!
  $demoData: Boolean!
  $questionFilters: [QuestionFilterInput]
  $commentExtraColumns: [ID]
  $count: Int!
  $cursor: String
) {
  question(id: $questionId) {
    ...CommentsWidgetList_question
    id
  }
}

fragment CommentsWidgetList_question on Question {
  id
  type
  answers(from: $from, to: $to, deviceIds: $deviceIds, filterComments: $filterComments, demoData: $demoData, questionFilters: $questionFilters, lookupAnswersToQuestions: $commentExtraColumns, first: $count, after: $cursor) {
    edges {
      node {
        id
        ...CommentsWidgetListItem_answer
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment CommentsWidgetListItem_answer on Answer {
  id
  localTime
  comment
  selectedOptions
  device {
    name
    location
    id
  }
  responderAnswers {
    questionMongoId
    questionText {
      language
      text
    }
    questionType
    questionOptions {
      value
      text {
        language
        text
      }
    }
    comment
    selectedOptions
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "questionId",
        "type": "ID!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "from",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "to",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "deviceIds",
        "type": "[ID]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "filterComments",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "demoData",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "questionFilters",
        "type": "[QuestionFilterInput]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "commentExtraColumns",
        "type": "[ID]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsWidgetListPaginationQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "questionId",
            "type": "ID"
          }
        ],
        "concreteType": "Question",
        "name": "question",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CommentsWidgetList_question",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CommentsWidgetListPaginationQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "questionId",
        "type": "ID!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "from",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "to",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "deviceIds",
        "type": "[ID]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "filterComments",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "demoData",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "questionFilters",
        "type": "[QuestionFilterInput]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "commentExtraColumns",
        "type": "[ID]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "CommentsWidgetListPaginationQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "questionId",
            "type": "ID"
          }
        ],
        "concreteType": "Question",
        "name": "question",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "type",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "demoData",
                "variableName": "demoData",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "deviceIds",
                "variableName": "deviceIds",
                "type": "[ID]"
              },
              {
                "kind": "Variable",
                "name": "filterComments",
                "variableName": "filterComments",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "from",
                "variableName": "from",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "lookupAnswersToQuestions",
                "variableName": "commentExtraColumns",
                "type": "[ID]"
              },
              {
                "kind": "Variable",
                "name": "questionFilters",
                "variableName": "questionFilters",
                "type": "[QuestionFilterInput]"
              },
              {
                "kind": "Variable",
                "name": "to",
                "variableName": "to",
                "type": "String"
              }
            ],
            "concreteType": "AnswerConnection",
            "name": "answers",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "AnswerEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Answer",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "localTime",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "comment",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "selectedOptions",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Device",
                        "name": "device",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "location",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "ResponderAnswer",
                        "name": "responderAnswers",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "questionMongoId",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Translation",
                            "name": "questionText",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "language",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "text",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "questionType",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Option",
                            "name": "questionOptions",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "value",
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "Translation",
                                "name": "text",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "language",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "text",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "comment",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "selectedOptions",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "demoData",
                "variableName": "demoData",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "deviceIds",
                "variableName": "deviceIds",
                "type": "[ID]"
              },
              {
                "kind": "Variable",
                "name": "filterComments",
                "variableName": "filterComments",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "from",
                "variableName": "from",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "lookupAnswersToQuestions",
                "variableName": "commentExtraColumns",
                "type": "[ID]"
              },
              {
                "kind": "Variable",
                "name": "questionFilters",
                "variableName": "questionFilters",
                "type": "[QuestionFilterInput]"
              },
              {
                "kind": "Variable",
                "name": "to",
                "variableName": "to",
                "type": "String"
              }
            ],
            "handle": "connection",
            "name": "answers",
            "key": "CommentsWidgetList_answers",
            "filters": [
              "from",
              "to",
              "deviceIds",
              "filterComments",
              "demoData",
              "questionFilters",
              "lookupAnswersToQuestions"
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query CommentsWidgetListPaginationQuery(\n  $questionId: ID!\n  $from: String!\n  $to: String!\n  $deviceIds: [ID]!\n  $filterComments: Boolean!\n  $demoData: Boolean!\n  $questionFilters: [QuestionFilterInput]\n  $commentExtraColumns: [ID]\n  $count: Int!\n  $cursor: String\n) {\n  question(id: $questionId) {\n    ...CommentsWidgetList_question\n    id\n  }\n}\n\nfragment CommentsWidgetList_question on Question {\n  id\n  type\n  answers(from: $from, to: $to, deviceIds: $deviceIds, filterComments: $filterComments, demoData: $demoData, questionFilters: $questionFilters, lookupAnswersToQuestions: $commentExtraColumns, first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        ...CommentsWidgetListItem_answer\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CommentsWidgetListItem_answer on Answer {\n  id\n  localTime\n  comment\n  selectedOptions\n  device {\n    name\n    location\n    id\n  }\n  responderAnswers {\n    questionMongoId\n    questionText {\n      language\n      text\n    }\n    questionType\n    questionOptions {\n      value\n      text {\n        language\n        text\n      }\n    }\n    comment\n    selectedOptions\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/CommentsWidgetList/__generated__/CommentsWidgetListPaginationQuery.graphql.js